import { VariantProps, cva } from 'class-variance-authority';

export const buttonStyles = cva(
  [
    'inline-flex',
    'text-grayscale0',
    'leading-1',
    'text-nowrap',
    'items-center',
  ],
  {
    variants: {
      intent: {
        cta: [
          'bg-success300',
          'hover:bg-success200',
          'active:bg-success400',
          'disabled:bg-grayscale300 data-[disabled="true"]:bg-grayscale300 data-[disabled="true"]:bg-grayscale300',
        ],
        primary: [
          'bg-primaryMain',
          'hover:bg-primary400',
          'active:bg-primary600',
          'disabled:bg-grayscale300 data-[disabled="true"]:bg-grayscale300',
        ],
        secondary: [
          'bg-grayscale0',
          'hover:bg-primary50',
          'active:bg-primary100',
          'disabled:border-grayscale300 data-[disabled="true"]:border-grayscale300',
          'disabled:text-grayscale300 data-[disabled="true"]:text-grayscale300',
          'border-2',
          'border-primaryMain',
          'text-primary600',
        ],
        tertiary: [
          'bg-primary50',
          'hover:bg-primary100',
          'active:bg-primary200',
          'disabled:bg-grayscale50 data-[disabled="true"]:bg-grayscale50',
          'disabled:text-grayscale300 data-[disabled="true"]:text-grayscale300',
          'text-primary600',
        ],
        error: [
          'bg-error300',
          'hover:bg-error200',
          'active:bg-error400',
          'disabled:bg-grayscale300 data-[disabled="true"]:bg-grayscale300',
        ],
        info: [
          'bg-info300',
          'hover:bg-info200',
          'active:bg-info400',
          'disabled:bg-grayscale300 data-[disabled="true"]:bg-grayscale300',
        ],
        success: [
          'bg-success300',
          'hover:bg-success200',
          'active:bg-success400',
          'disabled:bg-grayscale300 data-[disabled="true"]:bg-grayscale300',
        ],
        warning: [
          'bg-warning300',
          'hover:bg-warning200',
          'active:bg-warning400',
          'disabled:bg-grayscale300 data-[disabled="true"]:bg-grayscale300',
        ],
      },
      size: {
        small: ['rounded-6', 'py-8 px-16'],
        default: ['rounded-6', 'py-12 px-16'],
        large: ['rounded-6', 'py-12 px-20'],
      },
    },
    defaultVariants: {
      intent: 'primary',
      size: 'default',
    },
  },
);

export type ButtonStylesVariants = VariantProps<typeof buttonStyles>;
